import {
  i
} from "./chunk.775UL347.js";

// src/components/jb-anchor/jb-anchor.css.ts
var jb_anchor_css_default = i`::part(anchor){--_additional-spacing-block: max(calc((var(--minimum-touch-target-height, 24px) - 1lh) / 2), 0px);display:inline-block;margin-block:calc(-1*var(--_additional-spacing-block));padding-block:var(--_additional-spacing-block)}::part(anchor){display:inline-block;isolation:isolate;position:relative}.sr-only{block-size:1px;border:0;clip:rect(0, 0, 0, 0);inline-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute}:host{color:inherit;display:block;font:inherit;position:relative}::part(anchor).inactive{cursor:default;opacity:.4;pointer-events:none}`;

export {
  jb_anchor_css_default
};
